import type { ValuesType } from "utility-types";

export const VisitTypeTemplateName = {
    Execution: null as null,
    AfterSalesService: "afterSalesService",
    Delivery: "delivery",
    HandoverToRealization: "handoverToRealization",
    RealizationToHandover: "realizationToHandover",
    WorkPackage: "workpackage",
    Automation: "automation",
    HiddenExecution: "hiddenExecution",
    HiddenDelivery: "hiddenDelivery",
} as const satisfies Record<string, string | null>;
export type VisitTypeTemplateName = ValuesType<typeof VisitTypeTemplateName>;

export const EquivBugTransition = {
    EquivTransitionNone: 0,
    EquivTransitionAccept: 1,
    EquivTransitionReject: 2,
    EquivTransitionEnter: 3,
} as const satisfies Record<string, number>;
export type EquivBugTransition = ValuesType<typeof EquivBugTransition>;

export const BugTransitionActivation = {
    TransitionActivationNone: 0,
    TransitionActivationIfEveryLinkClosed: 1,
    TransitionActivationIfNotEveryLinkClosed: 2,
    TransitionActivationIfAutoAcceptanceOfBug: 3,
    /**
     * This is a special case for the system transition that is activated by the system and not by the user.
     */
    TransitionActivationExplicitSystemTransition: 4,
    TransitionActivationEveryLinkIsSolved: 5,
    TransitionActivationEveryLinkIsOpen: 6,
} as const satisfies Record<string, number>;
export type BugTransitionActivation = ValuesType<typeof BugTransitionActivation>;

export const EquivBugState = {
    EquivStateNone: 0,
    EquivStateOpen: 1,
    EquivStateClosed: 2,
    EquivStateOpenAlt: 3,
    EquivStateClosedAlt: 4,
    EquivStateClosedRejected: 5,
    EquivStateClosing: 6,
    EquivStateClosedFinal: 7,
} as const satisfies Record<string, number>;
export type EquivBugState = ValuesType<typeof EquivBugState>;

export const BugStateAction = {
    StateActionNone: 0,
    StateActionCopyBug: 1,
    StateActionCleanupBugLinks: 2,
} as const satisfies Record<string, number>;
export type BugStateAction = ValuesType<typeof BugStateAction>;

export const BugGroupRelationType = {
    BugGroupRelationNone: 0,
    BugGroupAllowingDelete: 1,
    BugGroupAllowingRead: 2,
    BugGroupAllowingCreateVisit: 3,
} as const satisfies Record<string, number>;
export type BugGroupRelationType = ValuesType<typeof BugGroupRelationType>;
